<div class="ui-menu">
  <button
    type="button"
    class="ui-menu__trigger"
    [attr.aria-expanded]="open()"
    (click)="toggle()"
  >
    <span>{{ label() }}</span>
    <span class="ui-menu__chevron" [class.ui-menu__chevron--open]="open()" aria-hidden="true">▾</span>
  </button>

  @if (open()) {
    <div class="ui-menu__dropdown" role="menu">
      @if (items().length > 0) {
        @for (item of items(); track $index) {
          <button
            type="button"
            class="ui-menu__item"
            [class.ui-menu__item--disabled]="item.disabled"
            [disabled]="item.disabled"
            role="menuitem"
            (click)="select(item)"
          >
            {{ item.label }}
          </button>
        }
      } @else {
        <ng-content />
      }
    </div>
  }
</div>
